import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 8c0-.6.4-1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1ZM4 16c0-.6.4-1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1ZM5 23a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H5Z" })
});
export default SvgList;
